<template>
  <div class="row justify-content-center" style="width: 100%;">
    <div class="col-lg-5 col-md-7">
      <div class="card shadow border-3">
        <div
          class="card-body px-lg-6 py-lg-9"
        >
          <div class="logo-home">
            <img :src="appLogo" />
          </div>
          <form role="form">
            <base-input
              class="input-group-alternative mb-3"
              placeholder="Email"
              addon-left-icon="ni ni-email-83"
              v-model="model.email"
            ></base-input>

            <base-input
              class="input-group-alternative"
              placeholder="Mot de passe"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="model.password"
            ></base-input>
            <div class="text-center">
              <base-button style="background-color:#000; width: 150px; height:50px;color:#fff" class="my-4" @click="login">Connexion</base-button>
            </div>
          </form>
        </div>
      </div>
      <!--  <div class="row mt-3">
                    <div class="col-6">
                        <a href="#" class="text-light"><small>Forgot password?</small></a>
                    </div>
                    <div class="col-6 text-right">
                        <router-link to="/register" class="text-light"><small>Create new account</small></router-link>
                    </div>
      </div>-->
    </div>
  </div>
</template>
<script>
import { post } from "@/mixins/api";
import constants from '@/mixins/constants'
export default {
  name: "login",
  mixins: [constants],
  data() {
    return {
      model: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    login(e) {
      let self = this;
      e.preventDefault();
      post("login", this.model)
        .then(resp => {
          const result = resp.data;
          localStorage.setItem("accessToken", result.accessToken);
          localStorage.setItem("user", JSON.stringify(result.data));
          this.$router.push("home");
          console.log(result);
        })
        .catch(error => {
          // console.log(error);
          this.$bvToast.toast("login ou mot de passe incorrecte", "error", {
            title: "login ou mot de passe incorrecte.",
            variant: "danger",
            solid: true,
          });
        }).finally(() => this.model = {
            email: "",
            password: ""
          })
    }

    /*  login(){
      this.$router.push('home')
        } */
  }
};
</script>
<style lang="scss">
  .logo-home {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
    img {
      width: 180px;
    }
}
</style>
